"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = CalendarHolidayDay;
var react_1 = __importDefault(require("react"));
var primitives_1 = require("web/components/primitives");
var classnames_1 = __importDefault(require("classnames"));
var styles_scss_1 = __importDefault(require("./styles.scss"));
function CalendarHolidayDay(_a) {
    var _b;
    var holiday = _a.holiday, activitiesPerDay = _a.activitiesPerDay, _c = _a.isPrintMode, isPrintMode = _c === void 0 ? false : _c, _d = _a.isWeekView, isWeekView = _d === void 0 ? false : _d;
    var content = null;
    if (activitiesPerDay === 1 && !isPrintMode) {
        content = (react_1.default.createElement(primitives_1.FlexContainer, { alignItems: "center", className: styles_scss_1.default.calendarHolidayDayNoText },
            react_1.default.createElement(primitives_1.Icon, { type: primitives_1.IconType.bell, size: 8, className: styles_scss_1.default.bellSmall })));
    }
    else {
        content = (react_1.default.createElement(primitives_1.FlexContainer, { alignItems: "center", className: (0, classnames_1.default)('', (_b = {},
                _b[styles_scss_1.default['calendarHolidayDay--weekPrint']] = isWeekView,
                _b[styles_scss_1.default.calendarHolidayDay] = !isPrintMode,
                _b[styles_scss_1.default['calendarHolidayDay--print']] = isPrintMode,
                _b)) },
            !isPrintMode && (react_1.default.createElement(primitives_1.Icon, { type: primitives_1.IconType.bell, size: 10, className: styles_scss_1.default.bell })),
            react_1.default.createElement(primitives_1.FlexContainer, { justifyContent: "center", alignItems: "center" }, holiday.name)));
    }
    return content;
}
